// extracted by mini-css-extract-plugin
module.exports = {"efCollectionH5":"VersionEU_efCollectionH5__D5vIG"};